module.exports = __webpack_public_path__ + "8bf3d96b4bd93bd40a00c23d1fc56a44.mp4";